function _(r,t,n){var o=r(44),i=r(8),a=r(48),e=r(24).iterator,f=Array.isArray;t.exports=function(r){return!!i(r)&&(!!f(r)||(!!a(r)||(!!o(r)||"function"==typeof r[e])))}}
//# sourceMappingURL=is-iterable.min.js.map